import {useState, useEffect} from 'react';
import { H3, Panel, Flex, FlexItem, Button, Text, Box, Modal, Form, FormGroup, Input, Select, Checkbox, Fieldset } from '@bigcommerce/big-design';
import { AddIcon, RemoveCircleOutlineIcon, AddCircleOutlineIcon } from '@bigcommerce/big-design-icons';


export default function Attendee({ attendee, isOpen, setIsOpen }) {
    
    return (
        <Modal
            actions={[
            {
                text: 'Close',
                variant: 'primary',
                onClick: () => setIsOpen(false),
            }
            ]}
            closeOnClickOutside={true}
            closeOnEscKey={true}
            header="Attendee Details"
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            id='field-form'
        >
            <Box id='edit-field' marginBottom={'large'}>
                <dl>
                    {attendee.formValues.map((f, i) => {
                        return (
                            <div key={i}>
                                <dt>{f.label}</dt>
                                <dd>{f.value}</dd>
                            </div>
                        );
                    })}
                </dl>
            </Box>
        </Modal>
    );
}